import { createSlice } from "@reduxjs/toolkit";
import { getFirstTimeCustomers } from "./firstTimeCustomersAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  customers: [],
  meta: null,
  latestRequestId: null,
};

const firstTimeCustomersSlice = createSlice({
  name: "firstTimeCustomers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFirstTimeCustomers.pending, (state, action) => {
        state.loading = true;
        state.customers = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getFirstTimeCustomers.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.customers = action.payload?.results ?? action.payload;
        state.meta = action.payload?.meta ?? null;
        state.error = null;
      })
      .addCase(getFirstTimeCustomers.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default firstTimeCustomersSlice.reducer;
